import { useState } from "react";
import { useTranslation } from "react-multi-lang";

const TicketSalesHistory = ({ item }) => {
  const t = useTranslation();
  const [showDetail, setShowDetail] = useState(false);
  let statusName;
  let statusColor;
  let statusTextColor;
  switch (item.status) {
    case "COMPLETED":
      statusName = t("general.completed");
      statusColor = "bg-[#A7FFA1]";
      statusTextColor = "text-[#047100]";
      break;
    case "CANCELED":
      statusName = t("general.cancelled");
      statusColor = "bg-[#FF9191]";
      statusTextColor = "text-white";
      break;
    case "PENDING":
      statusName = t("general.pending");
      statusColor = "bg-[#FCB769]";
      statusTextColor = "text-white";
      break;
    default:
      statusName = "";
      statusColor = "";
      statusTextColor = "";
      break;
  }
  return (
    <div className="bg-white rounded-xl m-2">
      <div className="sm:text-sm flex flex-row p-5">
        <div className="flex-1">
          <span className="inline-block text-gold-secondary font-bold">
            {item.titleTicket}
          </span>
          <span className="inline-block mx-1">/</span>
          {item.date}
        </div>
        <div>
          <span
            className={`px-2 py-1 ${statusColor} ${statusTextColor} rounded-md`}
          >
            {statusName}
          </span>
        </div>
      </div>
      <hr />
      {/* header */}
      <div
        onClick={() => setShowDetail(!showDetail)}
        className="p-5 flex items-center justify-between cursor-pointer hover:bg-gray-50 rounded-b-md"
      >
        <div className="text-md font-bold">{t("balance.received")}</div>
        <div className="flex items-center gap-2">
          <div className="flex-1 text-right text-md font-bold">
            Rp{item.balanceReceived}
          </div>
          <img
            src={process.env.REACT_APP_ASSETS_IMAGE + "arrow.svg"}
            alt=""
            className={showDetail ? "rotate-180" : ""}
          />
        </div>
      </div>
      <hr />
      {/* body */}
      {showDetail && (
        <div className="p-5 flex flex-col gap-3">
          <div className=" flex items-center justify-between">
            <p className="font-bold">{t("balance.total_order")}</p>
            <span className="text-gray-400 font-medium">
              {item.priceTotal}
            </span>
          </div>
          <div className=" flex items-center justify-between">
            <p className="font-bold">{t("balance.commission")}</p>
            <span className="text-gray-400 font-medium">
              -Rp{item.productCommission}
            </span>
          </div>
          <div className=" flex items-center justify-between">
            <p className="font-bold">{t("balance.shipping_const")}</p>
            <span className="text-gray-400 font-medium">
              -Rp{item.shipping}
            </span>
          </div>
          <div className=" flex items-center justify-between">
            <p className="font-bold">{t("balance.insurance_fee")}</p>
            <span className="text-gray-400 font-medium">
              -Rp{item.insurance}
            </span>
          </div>
          <div className=" flex items-center justify-between">
            <p className="font-bold">{t("balance.admin_application_fee")}</p>
            <span className="text-gray-400 font-medium">
              -Rp{item.adminApplicationFee}
            </span>
          </div>
          <div className=" flex items-center justify-between">
            <p className="font-bold">{t("balance.transaction_service_fee")}</p>
            <span className="text-gray-400 font-medium">
              -Rp{item.transactionServiceFee}
            </span>
          </div>
          {item.totalPricePromo !== "0" ? (
            <div className=" flex items-center justify-between">
              <p className="font-bold">{t("balance.productPromo")}</p>
              <span className="text-gray-400 font-medium">
                -Rp{item.totalPricePromo}
              </span>
            </div>
          ) : (
            ""
          )}
          {item.totalShippingPromo !== "0" ? (
            <div className=" flex items-center justify-between">
              <p className="font-bold">{t("balance.shippingPromo")}</p>
              <span className="text-gray-400 font-medium">
                -Rp{item.totalShippingPromo}
              </span>
            </div>
          ) : (
            ""
          )}
          {item.totalAdminPromo !== "0" ? (
            <div className=" flex items-center justify-between">
              <p className="font-bold">{t("balance.productAdminPromo")}</p>
              <span className="text-gray-400 font-medium">
                -Rp{item.totalAdminPromo}
              </span>
            </div>
          ) : (
            ""
          )}
        </div>
      )}
      {/* footer */}
      {/* <div className="flex px-5 pb-5">
                <div>{t("balance.received")}</div>
                <div className="flex-1 text-right text-md font-bold">
                    Rp{item.balanceReceived}
                </div>
            </div> */}
    </div>
  );
};

export default TicketSalesHistory;
